import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Stack,
  TextField,
  Alert,
  Chip,
  Card,
  CardContent,
  Box,
} from "@mui/material";
import { MuiFileInput } from "mui-file-input";
import uploadBanner from "../../api/upload_banner";
import setTags from "../../api/store/setTags"; // Ensure correct import path
import getTags from "../../api/store/getTags"; // Ensure correct import path

function WebPage() {
  const [tags, setTagsState] = useState([]);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [file, setFile] = useState(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const data = await getTags();

        setTagsState(data.tags); // Adjust this if data structure differs
      } catch (err) {
        setError("Failed to load tags: " + err.message);
      }
    };

    fetchTags();
  }, []);

  const handleImgChange = (fileValue) => {
    setFile(fileValue);
  };

  const handleUploadClicked = async () => {
    try {
      const data = await uploadBanner(file);
      setIsSuccess(true);
      setFile(null);
    } catch (err) {
      setIsSuccess(false);
      setError(err.message);
    }
  };

  const handleSetTags = async () => {
    try {
      if (!tags.includes(inputValue.trim())) {
        console.log([...tags, inputValue.trim()]);
        setTagsState([...tags, inputValue.trim()]);
        setInputValue("");
      }
      const response = await setTags([...tags, inputValue.trim()]);
      setIsSuccess(true);
      console.log("Tags updated successfully:", response);
    } catch (err) {
      setIsSuccess(false);
      setError("Failed to set tags: " + err.message);
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setTagsState((prevTags) => prevTags.filter((tag) => tag !== tagToDelete));
  };

  const handleAddTag = (event) => {
    if (event.key === "Enter" && event.target.value.trim() !== "") {
      if (!tags.includes(event.target.value.trim())) {
        console.log([...tags, event.target.value.trim()]);
        setTagsState([...tags, event.target.value.trim()]);
        setInputValue("");
      }
    }
  };

  return (
    <div>
      <Card sx={{ margin: 1 }}>
        <CardContent>
          <Stack spacing={2} direction={"row"} alignItems="center">
            <Typography fontSize="large">網頁橫幅圖片</Typography>
            <MuiFileInput
              title="網頁橫幅圖片"
              placeholder="選擇圖片"
              color="info"
              inputProps={{ accept: "image/jpeg" }}
              value={file}
              onChange={handleImgChange}
              size="small"
            />
            <Button
              variant="contained"
              color="info"
              onClick={handleUploadClicked}
            >
              上傳
            </Button>
          </Stack>
        </CardContent>
      </Card>
      <Card sx={{ margin: 1 }}>
        <CardContent>
          <Stack direction="column" alignItems={"flex-start"} spacing={3}>
            <Box flexDirection={"row"} maxWidth={"100%"}>
              {tags.map((tag, index) => (
                <Chip
                  key={index}
                  label={tag}
                  onDelete={() => handleDeleteTag(tag)}
                  color="secondary"
                />
              ))}
            </Box>
            <Stack
              direction={"row"}
              spacing={1}
              height={"5vh"}
              alignItems={"center"}
            >
              {" "}
              <TextField
                label="輸入標籤"
                variant="outlined"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleAddTag}
              />
              <Button variant="contained" color="info" onClick={handleSetTags}>
                新增標籤
              </Button>
            </Stack>

            {isSuccess && <Alert severity="success">操作成功！</Alert>}
            {error && <Alert severity="error">{error}</Alert>}
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
}

export default WebPage;
